<template functional>
  <div class="office-layout container">
    <slot/>
  </div>
</template>

<script>
export default {
  name: "OfficeLayout"
}
</script>

<style scoped lang="scss">
.office-layout {
  margin-top: 7px;
  display: grid;
  grid-template-columns:300px 418px;
  grid-column-gap: 2rem;
  grid-row-gap: 2rem;
  padding-bottom: 80px;
  @media(min-width: 1200px) {
    grid-template-columns:340px 800px;
    grid-column-gap: 3rem;
    grid-row-gap: 3rem;
  }
}
</style>